import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ToastModel } from '../../models/other/toastHandler.model';
import { ToastMessageSeverity } from '../../enums/toastMessageTypes.enum';

@Injectable({
  providedIn: 'root',
})
export class ToastHandlerService {
  constructor() {}
  private subject = new Subject<ToastModel>();

  /**
   * Returns an observable that emits the toast messages.
   * This method is used to subscribe to the toast messages emitted by the service.
   * Any component can subscribe to this observable and handle the toast messages accordingly.
   *
   * @returns {Observable<any>} - An observable that emits toast messages.
   */
  public getToastEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  /**
   * Displays a toast message with the given severity, title, and body.
   *
   * @param {ToastMessageSeverity} type - The severity of the toast message. It should be an enum value from ToastMessageSeverity.
   * @param {string} title - The title of the toast message.
   * @param {string} body - The content of the toast message.
   *
   * @returns {void}
   */
  public showMessage(type: ToastMessageSeverity, title: string, body: string) {
    this.subject.next({
      severity: ToastMessageSeverity[type],
      summary: title,
      detail: body,
    });
  }
}
